import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import styles from './LandingPage.scss';
import ICBanner from 'common/components/banner/ICBanner'
import ICDashboard from './components/ICDashboard';

import { connect } from 'react-redux';
import * as actions from 'actions';

export class LandingPage extends React.Component {

  constructor(props) {
    super(props);
    let item = new URLSearchParams(this.props.location.search).get("q") ;
    item = (item === null) ? '': item;
    this.state = {filterText: item};
  }

  componentDidMount() {
    if (!this.props.initialized && !this.props.loading) {
      this.props.fetchJobsData();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let item = new URLSearchParams(this.props.location.search).get("q") ;
    item = (item === null) ? '': item;
    if (item !== this.state.filterText) {
      this.setState({filterText: item});
    }
  }

  handleDetails = (integrationId) => {
    this.props.history.push("/Details/" + integrationId);
  }

  handleFilterUpdateEvent = (e) => {
    this.props.history.push({search: 'q=' + e.detail.filteringText});
  }

  render() {

    const { loading, jobsData } = this.props;

    if (loading) {
      return <div>Loading ...</div>
    }

    return (
      <div className={styles.wrapper}>
        <ICBanner bannerText="Intercompany Data Integration and Transformation Tool for Intercompany Applications"></ICBanner>
        <br />
        <ICDashboard
          items={jobsData}
          onReviewDetails={this.handleDetails}
          onDelayedFilter={this.handleFilterUpdateEvent}
          filterText={this.state.filterText}
          history={this.props.history}
          handleSave={async (updatedData) => {await this.props.saveJobData(updatedData); await this.props.fetchJobsData()}}
        />
      </div>
    );
  }

}

const mapStateToProps = (state) => {

  const { fetchJobsData } = state;
  const { loading, jobsData, initialized } = fetchJobsData;

  return {
    loading: loading,
    jobsData: jobsData,
    initialized: initialized
  };
};

const mapDispatchToProps = {
  fetchJobsData: actions.fetchJobsData,
  saveJobData: actions.saveJobData
};

const LandingPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LandingPage);

export default withRouter(LandingPageContainer);
